
const SET_FCCOUNT = 'fc/SET_FCCOUNT';
 
export {   
    SET_FCCOUNT,
};